import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
// import AddSurveyIcon from "../../../components/Common/SvgIcons/ManageIcons/AddSurveyIcon";
// import PublishIcon from "../../../components/Common/SvgIcons/ManageIcons/PublishIcon";
import { colors } from "../../stripeColors";
import AddQuizIcon from "../../../components/Common/SvgIcons/ManageIcons/AddQuizIcon";
import { FormattedMessage } from "react-intl";

export let createNewEvent = {
  label: "Create New Events",
  editLabel: "Update Events",
  copyLabel: "Copy Events",
  viewLabel: "View Events",
  name: "Create Event",
  editpath: (tenantName) => `/${tenantName}/events/editEventClass`,
  copypath: (tenantName) => `/${tenantName}/events/copyEventClass`,
  viewpath: (tenantName) => `/${tenantName}/events/viewEventClass`,
  path: (location, params, tenantName) =>
    location?.pathname.includes(createNewEvent.editpath(tenantName))
      ? `${createNewEvent.editpath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(createNewEvent.copypath(tenantName))
      ? `${createNewEvent.copypath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(createNewEvent.viewpath(tenantName))
      ? `${createNewEvent.viewpath(tenantName)}/${params?.shotclassId}`
      : `/${tenantName}/events/createNewEvent`,
  icon: AddIcon,
  navLinks: (navigate, location, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="MANAGE_VQVT" />,
      path: `/${tenantName}/events`,
      onClick: () => navigate(`/${tenantName}/events`),
    },
    {
      key: 2,
      label: createNewEvent.name,
      label: location?.pathname.includes(createNewEvent.editpath(tenantName))
        ? createNewEvent.editLabel
        : location?.pathname.includes(createNewEvent.copypath(tenantName))
        ? createNewEvent.copyLabel
        : location?.pathname.includes(createNewEvent.viewpath(tenantName))
        ? createNewEvent.viewLabel
        : createNewEvent.label,
      path: `${location?.pathname}`,
      onClick: () => navigate(`${location?.pathname}`),
    },
  ],
  tiles: (navigate, location, params, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS_TEXT" />,
      path: `${createNewEvent.path(location, params, tenantName)}/details`,
      icon: (fill) => <DetailsIcon fill={fill} />,
      color: colors.green,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${createNewEvent.path(location, params, tenantName)}/details`
        ),
      formData: (
        allLanguageVariant,
        trainingTypes,
        eventNameExist,
        shotclassType
      ) => [
        {
          key: 1,
          label: "Course Language",
          name: "Language",
          fieldName: "Value",
          fieldValue: "Locale",
          type: "select",
          labelColor: "light",
          valueArray: allLanguageVariant,
          defaultValue: allLanguageVariant[0]?.Value,
          required: true,
        },
        {
          key: 2,
          label: <FormattedMessage id="USERGROUP_NAME" />,
          name: "Name",
          placeholder: <FormattedMessage id="MANAGE_TRAINING" />,
          labelColor: "light",
          onChange: eventNameExist,
          required: true,
        },
        {
          key: 3,
          label: <FormattedMessage id="TRAINING_TYPE" />,
          name: "TrainingType",
          fieldName: "Name",
          fieldValue: "TypeId",
          placeholder: "Select Training Type",
          type: "select",
          labelColor: "light",
          valueArr: trainingTypes,
          required: true,
        },
      ],
    },
    {
      key: 2,
      label: "Add Quiz",
      path: `${createNewEvent.path(location, params, tenantName)}/addQuiz`,
      icon: (fill) => <AddQuizIcon fill={fill} />,
      color: colors.purple,
      isCompleted: false,
      // optionalText: () => "(Optional)",
      onClick: () =>
        navigate(
          `${createNewEvent.path(location, params, tenantName)}/addQuiz`
        ),
    },
    // {
    //   key: 3,
    //   label: "Publish Shotclass",
    //   path: `${createNewEvent.path}/eventPublish`,
    //   color: colors.orange,
    //   isCompleted: false,
    //   icon: (fill) => <PublishIcon fill={fill} />,
    //   onClick: () => navigate(`${createNewEvent.path}/eventPublish`),
    // },
  ],
};
